import React, { Component } from "react";
import { withRouter, Redirect } from "react-router-dom";
import { connect } from "react-redux";

class OfflineExams extends Component {
  render() {
    return (
      <>
        <h4>Offline Exams</h4>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return { ...state.auth };
};
export default connect(mapStateToProps)(withRouter(OfflineExams));
